(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name AddressesController
* @description
* This is main controller
**/ 


    angular
    .module('app')
    .controller('AddressesController', AddressesController);

    AddressesController.$inject = ['AddressService'];


    function AddressesController(AddressService)
    {

    	var vm = this;
      vm.as = AddressService;
    
      vm.typeAddress = ['Primary Address','Billing Address'];
      
   		
          vm.as.reloadAddresses();

  }
})();